<script>
	import { LayerCake, Svg, Html } from "layercake";
	import AxisX from "./layercake/AxisX.svelte";
	import AxisY from "./layercake/AxisY.svelte";
	import SharedTooltip from "./layercake/SharedTooltip.svelte";
	import { parseISO, format } from "date-fns";
	import {
		timeParse,
		timeFormat,
		timeFormatDefaultLocale,
	} from "d3-time-format";
  
  import { scaleOrdinal } from 'd3-scale';
	import { afterUpdate, onMount } from "svelte";
import MultiLine from "./layercake/MultiLine.svelte";

	export let data;
	export let xKey = "imported";
	export let yKey = "value";
	export let viewRespirator = true;
  let zKey = "sus"
	let formatTickX;
	let getYTicks;
	timeFormatDefaultLocale({
			decimal: ".",
			thousands: ",",
			grouping: [3],
			currency: ["$", ""],
			dateTime: "%a %b %e %X %Y",
			date: "%m/%d/%Y",
			time: "%H:%M:%S",
			periods: ["AM", "PM"],
			days: [
				"Søndag",
				"Mandag",
				"Tirsdag",
				"Onsdag",
				"Torsdag",
				"Fredag",
				"Lørdag",
			],
			shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
			months: [
				"Januar",
				"Februar",
				"Mars",
				"April",
				"Mai",
				"Juni",
				"Juli",
				"August",
				"September",
				"Oktober",
				"November",
				"Desember",
			],
			shortMonths: [
				"jan.",
				"feb.",
				"mar.",
				"apr.",
				"mai.",
				"jun.",
				"jul.",
				"aug.",
				"sep.",
				"okt.",
				"nov.",
				"des.",
			],
		});
  const parseDate = timeParse("%Y-%m-%d");
  const seriesNames = viewRespirator ? [ 'innlagte', 'respirator',] : ['innlagte'];
  const seriesColors = [ '#222222', '#D8002B', '#ff7ac7', '#ff00cc'];

	data = data.slice(-25).map((d) => {
		if(viewRespirator) {
			return {
			imported: format(parseISO(d.imported), "yyyy-MM-dd"),
			respirator: d.respirator,
      		innlagte: d.hospitalized
		};
		} else {
			return {
			imported: format(parseISO(d.imported), "yyyy-MM-dd"),
      		innlagte: d.hospitalized
		};
		}
		
	});

	
	const dataLong = seriesNames.map(key => {
		return {
			[zKey]: key,
			values: data.map(d => {
				d[xKey] = typeof d[xKey] === 'string' ? parseDate(d[xKey]) : d[xKey]; // Conditional required for sapper
				return {
					[yKey]: +d[key],
					[xKey]: d[xKey]
				};
			})
		};
	});
  
  const flatten = data => data.reduce((memo, group) => {
    return memo.concat(group.values);
  }, []);

	formatTickX = timeFormat("%e. %b");

	getYTicks = (list) => {
		return [list[0], list[list.length - 1]];
	};

	afterUpdate(() => {
		
	});
	
</script>

<div class="chart-container">
	<LayerCake
		padding={{ right: 10, bottom: 20, left: 25 }}
		x={xKey}
		y={yKey}
    	z={zKey}
		yDomain={[0, null]}
    zScale={scaleOrdinal()}
    zDomain={seriesNames}
    zRange={seriesColors}
    flatData={flatten(dataLong)}
    data={dataLong}
	>
		<Svg>
			<AxisX
				gridlines={false}
				ticks={getYTicks(data.map((d) => d[xKey]).sort((a, b) => a - b))}
				formatTick={formatTickX}
				snapTicks={true}
			/>
			<AxisY ticks={3} />
			<MultiLine />
		</Svg>
		<Html>
			<SharedTooltip
				custom={true}
				valueKey={yKey}
				formatTitle={formatTickX}
				dataset={data}
			/>
		</Html>
	</LayerCake>
</div>

<style lang="scss">
	.chart-container {
		width: 100%;
		height: 100%;
	}
</style>
